/** @jsx dom */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var propTypes = {
	'class': {
		type: 'string'
	},
	items: {
		type: 'array'
	},
	onClick: {
		type: 'function'
	}
};

var initialState = function initialState() {
	return {
		activeTab: 0
	};
};

var onHeadingClick = function onHeadingClick(x, activeTab, i, setState, onClick) {
	return function () {
		if (activeTab === i) {
			return;
		}

		setState({ activeTab: i });

		if (onClick) {
			onClick((0, _objectAssign2['default'])(x, { i: i }));
		}
	};
};

var getHeadings = function getHeadings(_ref, _ref2, setState) {
	var items = _ref.items;
	var onClick = _ref.onClick;
	var activeTab = _ref2.activeTab;

	return items.map(function (x, i) {
		return (0, _magicVirtualElement2['default'])(
			'div',
			{ 'class': ['Tabs-heading', { 'Tabs-heading--active': activeTab === i }], onClick: onHeadingClick(x, activeTab, i, setState, onClick) },
			x.heading
		);
	});
};

var getTabs = function getTabs(_ref3, _ref4) {
	var items = _ref3.items;
	var activeTab = _ref4.activeTab;

	return items.map(function (_ref5, i) {
		var content = _ref5.content;
		return (0, _magicVirtualElement2['default'])(
			'div',
			{ 'class': ['Tab', { 'Tab--active': activeTab === i }], style: { display: activeTab === i ? 'block' : 'none' } },
			content
		);
	});
};

var setActive = function setActive(items, setState) {
	return items.forEach(function (el, i) {
		return el.active === true && setState({ activeTab: i });
	});
};

var afterMount = function afterMount(_ref6, el, setState) {
	var props = _ref6.props;
	return setActive(props.items, setState);
};
var shouldUpdate = function shouldUpdate(_ref7, nextProps, _ref8) {
	var props = _ref7.props;
	var state = _ref7.state;
	var activeTab = _ref8.activeTab;
	return !(0, _deepEqual2['default'])(props, nextProps) || state.activeTab !== activeTab;
};
var afterUpdate = function afterUpdate(_ref9, prevProps, prevState, setState) {
	var props = _ref9.props;
	return !(0, _deepEqual2['default'])(props, prevProps) && setActive(props.items, setState);
};

var render = function render(_ref10, setState) {
	var props = _ref10.props;
	var state = _ref10.state;

	return (0, _magicVirtualElement2['default'])(
		'div',
		{ 'class': ['Tabs', props['class']] },
		(0, _magicVirtualElement2['default'])(
			'div',
			{ 'class': 'Tabs-headings' },
			getHeadings(props, state, setState)
		),
		(0, _magicVirtualElement2['default'])(
			'div',
			{ 'class': 'Tabs-content' },
			getTabs(props, state)
		)
	);
};

exports['default'] = { afterMount: afterMount, afterUpdate: afterUpdate, initialState: initialState, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
module.exports = exports['default'];
